import { ReactNode, createContext, useContext, useEffect, useMemo, useState } from 'react';
import { Config } from '../config';

const ConfigContext = createContext<(Config & { debug: boolean }) | null>(null);

export interface ConfigProviderProps {
    children: ReactNode;
    config: Config;
}

export const ConfigProvider = ({ children, config }: ConfigProviderProps) => {
    const [debug, setDebug] = useState(false);

    useEffect(() => {
        globalThis.debug = {
            enable() {
                setDebug(true);
            },
            disable() {
                setDebug(false);
            },
        };

        return () => {
            delete globalThis.debug;
        };
    });

    const value = useMemo(() => ({ ...config, debug }), [config, debug]);

    return <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>;
};

export const useConfig = () => {
    const config = useContext(ConfigContext);

    if (!config) {
        throw new Error('Missing ConfigProvider');
    }

    return config;
};
